import React from "react";
import { TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { StyledTable } from "./Table.styled";
import { makeStyles } from "@material-ui/core/styles";

type SortType = "asc" | "desc";

interface HeadCell {
    id: string;
    isUnsortable?: boolean;
    numeric: boolean;
    disablePadding: boolean;
    label: string;
}

interface Table {
    headCells: HeadCell[];
    disableControls?: boolean;
    order?: SortType;
    orderBy?: string;
    onSort?(id: string): () => void;
}

const useStyles = makeStyles({
    container: {
        maxHeight: 600,
    },
});

export const Table: React.FC<Table> = ({
    headCells,
    onSort,
    order = "asc",
    orderBy = "asc",
    disableControls = false,
    children,
}) => {
    // TODO: wrap with styled components when possible
    const classes = useStyles();

    return (
        // TODO: FIX wrapping component with styled-components does not work properly, why?
        <TableContainer component={Paper} className={classes.container}>
            <StyledTable stickyHeader>
                <TableHead>
                    <TableRow>
                        {headCells.map((headCell) => {
                            if (headCell.isUnsortable) {
                                return <TableCell>{headCell.label}</TableCell>;
                            }

                            return (
                                <TableCell
                                    key={headCell.id}
                                    align="left"
                                    sortDirection={orderBy === headCell.id ? order : false}>
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy === headCell.id ? order : "asc"}
                                        onClick={onSort?.(headCell.id)}>
                                        {headCell.label}
                                    </TableSortLabel>
                                </TableCell>
                            );
                        })}
                        {!disableControls && <TableCell />}
                    </TableRow>
                </TableHead>
                <TableBody>{children}</TableBody>
            </StyledTable>
        </TableContainer>
    );
};
